import { useEffect } from 'react';
import { useToast } from '../components/Toast';
import { PRIVATE_URIS } from '../constants/privateURIs.constants';
import { useSocket } from '../context/WebsocketContext';
import { VOUCH_COPY } from '../pages/Vouch/vouch.copy';

interface VouchReceivedData {
  sharerUsername?: string;
  credits?: number;
}

/**
 * App-level subscriber (TRIL-400): toasts the recipient whenever someone
 * vouches for them, wherever they are in the app. Tapping the toast deep-links
 * to /vouch. The /vouch received-list refetch is a separate subscriber
 * (useReceivedVouches). Mounted once in App.tsx.
 */
export function useVouchReceivedToast() {
  const enabled = import.meta.env.VITE_ENABLE_VOUCHING === 'true';
  const { onEvent } = useSocket();
  const { showToast } = useToast();

  useEffect(() => {
    if (!enabled) return;
    return onEvent('vouch_received', (data: VouchReceivedData) => {
      showToast({
        title: VOUCH_COPY.toastReceivedTitle,
        body: VOUCH_COPY.toastReceivedBody(
          data?.sharerUsername ?? '',
          data?.credits ?? 0,
        ),
        href: PRIVATE_URIS.VOUCH,
      });
    });
  }, [enabled, onEvent, showToast]);
}
